export default __webpack_public_path__ + "static/media/banner-logo.5ea212d1.jpeg";